import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { PropertyDealWithPrices } from "~/models/PropertyDeal";

const buildShowPath = (id: number): string => `/property_deals/${id}`;
// global mutateで使用するキー
export const propertyDealCacheKey = (id: number): string => buildShowPath(id);

export const usePropertyDeal = (
	id: number
): SwrReturnType<PropertyDealWithPrices> => {
	const swrKey = buildShowPath(id);
	const { data, mutate, error, isLoading } =
		useSWR<PropertyDealWithPrices>(swrKey);

	return {
		data: data ?? null,
		error,
		isLoading,
		mutate
	};
};
